<div style="margin-top: 50px" fxLayout="column" fxLayoutAlign="center center" *ngIf="!caregiverNotes">
  <mat-spinner></mat-spinner>
</div>

<form *ngIf="caregiverNotes" [formGroup]="actionItemFormGroup" novalidate autocomplete="off">
  <app-mat-simple-select
    [label]="fieldLabels['incomingAnsweredReasonId']"
    name="incomingAnsweredReasonId"
    placeholder="Reason"
    [selectItems]="caregiverNotes"
    formControlName="incomingAnsweredReasonId"
  ></app-mat-simple-select>

  <app-mat-simple-select
    [label]="fieldLabels['incomingMissedReasonId']"
    name="incomingMissedReasonId"
    placeholder="Reason"
    [selectItems]="caregiverNotes"
    formControlName="incomingMissedReasonId"
  ></app-mat-simple-select>

  <app-mat-simple-select
    [label]="fieldLabels['incomingMailboxReasonId']"
    name="incomingMailboxReasonId"
    placeholder="Reason"
    [selectItems]="caregiverNotes"
    formControlName="incomingMailboxReasonId"
  ></app-mat-simple-select>

  <app-mat-simple-select
    [label]="fieldLabels['outgoingAnsweredReasonId']"
    name="outgoingAnsweredReasonId"
    placeholder="Reason"
    [selectItems]="caregiverNotes"
    formControlName="outgoingAnsweredReasonId"
  ></app-mat-simple-select>

  <app-mat-simple-select
    [label]="fieldLabels['outgoingMissedReasonId']"
    name="outgoingMissedReasonId"
    placeholder="Reason"
    [selectItems]="caregiverNotes"
    formControlName="outgoingMissedReasonId"
  ></app-mat-simple-select>

  <app-hha-note-template [noteFormControl]="templateNoteFormControl"></app-hha-note-template>
</form>
